





























































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import CustomerServiceSearch from "@/modules/customerservice/List/components/Search.vue";
import {CustomerServiceStore} from "@/modules/customerservice/store";
import {CustomerServiceParams} from "@/modules/customerservice/params";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import CustomerServiceTableAction from "@/modules/customerservice/List/components/TableAction.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {listSite} from "@/modules/sites/services";
import XLSX from "xlsx";
import {openDownloadDialog, sheet2blob} from "@/shared/services/helper/utils";
import {RoleDeclare} from "@/enums/roledeclare";
import {listCustomerService} from "@/modules/customerservice/services";
import CustomerServiceExcel from "@/modules/customerservice/List/components/Excel/index.vue";


const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 100,
        scopedSlots: { customRender: "action" },
        align: 'center',
        fixed: 'left',
        ellipsis: true
    },
    {
        title: "Lịch hẹn tư vấn",
        dataIndex: "adviseSchedule",
        key: "adviseSchedule",
        width: 150,
        scopedSlots: { customRender: "adviseSchedule" },
        align: 'center',
        ellipsis: true
    },
    {
        title: "Tên công ty/tổ chức",
        dataIndex: "customerName",
        key: "customerName",
        scopedSlots: { customRender: "customerName" },
        width: 200,
        align: 'center',
        ellipsis: true
    },
    {
        title: "NVKD phụ trách",
        dataIndex: "employee.name",
        key: "employee",
        width: 150,
        scopedSlots: { customRender: "employee" },
        ellipsis: true
    },
    {
        title: "Tỉ lệ (%) chốt sale",
        dataIndex: "successRate",
        key: "successRate",
        scopedSlots: { customRender: "successRate" },
        width: 150,
        align: 'center',
        ellipsis: true
    },
    {
        title: "Đối thủ cạnh trạnh",
        dataIndex: "competitors",
        key: "competitors",
        width: 150,
        scopedSlots: { customRender: "competitors" },
        ellipsis: true
    },
    {
        title: "Doanh thu ước tính",
        dataIndex: "estimatedRevenue",
        key: "estimatedRevenue",
        width: 150,
        scopedSlots: { customRender: "estimatedRevenue" },
        ellipsis: true
    },
    {
        title: "Nguồn tìm kiếm thông tin",
        dataIndex: "infoResource",
        key: "infoResource",
        width: 150,
        scopedSlots: { customRender: "infoResource" },
        ellipsis: true
    },
    {
        title: "Ngày báo giá",
        dataIndex: "quotationDate",
        key: "quotationDate",
        width: 150,
        scopedSlots: { customRender: "quotationDate" },
        ellipsis: true
    },
    {
        title: "Địa chỉ giao dịch",
        dataIndex: "address",
        key: "address",
        scopedSlots: { customRender: "address" },
        width: 200,
        align: 'center',
        ellipsis: true
    },
    {
        title: "Yêu cầu dịch vụ",
        dataIndex: "serviceRequest",
        key: "name",
        width: 200,
        ellipsis: true
    },
    {
        title: "Ngành nghề KD",
        dataIndex: "businessLine",
        key: "businessLine",
        width: 150,
        scopedSlots: { customRender: "businessLine" },
        ellipsis: true
    },
    {
        title: "Người tạo",
        dataIndex: "createdBy.employee.fullname",
        key: "createByName",
        width: 150,
        scopedSlots: { customRender: "createByName" },
        ellipsis: true
    },
    {
        title: "Ngày giờ tạo",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        scopedSlots: { customRender: "createdDate" },
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 150,
        scopedSlots: { customRender: "status" },
        ellipsis: true
    }
]
@Component({
    name: "CustomerServiceList",
    components: {
        CustomerServiceExcel,
        CustomerServiceSearch, CommonStatusLabel, CustomerServiceTableAction, TooltipLabel}
})
export default class extends mixins(CommonMixin){
    columns = [...columns];
    exporting = false
    visibleProgress = false
    dataExcel = [] as any
    percentLoaded = 0
    
    created() {
        const params = new CustomerServiceParams();
        CustomerServiceStore.updateParams(params);
        CustomerServiceStore.listCustomerService(params);
    }
    
    get customerServices() {
        return CustomerServiceStore.ids.map((id: number) => CustomerServiceStore.data[id]);
    }
    
    get pagination() {
        return {
            current: CustomerServiceStore.meta.page,
            pageSize: CustomerServiceStore.meta.limit,
            total: CustomerServiceStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} KH`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }
    
    onChangePage(pagination: any) {
        CustomerServiceStore.listCustomerService({...CustomerServiceStore.params, page: pagination.current, limit: pagination.pageSize});
    }
    
    async onConfirm(id: any) {
        try {
            await CustomerServiceStore.deleteCustomerService(id);
            this.$message.success("Xóa thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa thất bại");
        }
    }

    async exportExcel() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_EXPORT_CUSTOMER_SERVICE)) {
            this.$notification.warn({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        try {
            this.exporting = true;
            this.visibleProgress = true;
            const { data } = await listCustomerService({ page: 1, limit: 200 });
            this.dataExcel = [];
            this.dataExcel = [...this.dataExcel, ...data.datas];
            for (let i = 2; i <= data.meta?.totalPage; i++) {
                const { data } = await listSite({ page: i, limit: 200 });
                this.dataExcel = [...this.dataExcel, ...data.datas];
                this.percentLoaded = Math.round(i/data.meta?.totalPage * 100);
            }
            setTimeout(() => {
                this.visibleProgress = false;
                const table1 = document.querySelector("#table-excel-customer-service");
                const opt = {
                    raw: true
                };
                const sheet = XLSX.utils.table_to_sheet(table1);
                openDownloadDialog(sheet2blob(sheet, 'Chăm sóc khách hàng'), 'Chăm sóc khách hàng.xlsx');
            }, 500)
        } catch (e) {
            console.log(e)
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        } finally {
            this.exporting = false;
        }
    }
}
